import EditablePropsType from '../../../types/composer';

/**
 * Resolves a fontStyleSchema selection to a font-family class. The global
 * `* { font-family }` rule overrides ancestor font classes, so the returned
 * class must be applied to each text element directly, not a container.
 * 'default' (the schema's sentinel) and empty values resolve to `fallback`.
 */
export const getFontClass = (fontStyle?: string, fallback?: string) =>
  fontStyle && fontStyle !== 'default' ? fontStyle : fallback;

export const fontStyleSchema = {
  type: EditablePropsType.Select,
  label: 'Font Style',
  name: 'fontStyle',
  selectOptions: {
    options: [
      { value: 'default', label: 'Default' },
      { value: 'font-tannerscript', label: 'TannerScript' },
      { value: 'font-national-2', label: 'National 2' },
    ],
  },
};

export const fontSizeSchema = {
  type: EditablePropsType.Select,
  label: 'Font Size',
  name: 'fontSize',
  selectOptions: {
    options: [
      { value: 'default', label: 'Default' },
      { value: 'text-sm', label: 'Small' },
      { value: 'text-base', label: 'Medium' },
      { value: 'text-lg', label: 'Large' },
      { value: 'text-xl', label: 'Extra Large' },
      { value: 'text-2xl', label: '2X Large' },
      { value: 'text-3xl', label: '3X Large' },
      { value: 'text-4xl', label: '4X Large' },
      { value: 'text-5xl', label: '5X Large' },
      { value: 'text-6xl', label: '6X Large' },
    ],
  },
};
